import DefaultController from './../../controller';

class Controller extends DefaultController{

    constructor(parent, blueprint={}){

        super(parent, blueprint);
        this.type = 'stop'; 

    }

}


let Blueprint = {
    type: Controller,
    properties: { 
        style: {
            stopOpacity: '1'
        },
        attributes: {
            'offset': '0'
        }
     },
    children: [  ]
}

export default Blueprint;
export {Controller, Blueprint};